import { TransitionContainer } from '@nutastic/nutastic-react-app';

export const CONSTANTS = {
    ANIMATE_BACK: TransitionContainer.DIRECTIONS.BACK,
    ANIMATE_FORWARD: TransitionContainer.DIRECTIONS.FORWARD,
    APP_TRANSITION_TIME: 1000,
    APPKEY_AUDIO_SERIES: 'kitchen',
    APPKEY_NEWS: 'news',
    APPKEY_VIDEO: 'video',
    APPKEY_SHOP: 'shop',
    CONTENT_BAR_WIDTH_PCT: 30
};

export const BANNER_SWIPER_PROPS = {
    autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    loop: true,
    slidesPerView: 1.25,
    direction: 'horizontal',
    effect: 'slide'
};

export const COVER_SWIPER_PROPS = {
    autoplay: false,
    loop: false,
    slidesPerView: 5.25,
    direction: 'horizontal',
    effect: 'slide'
};
